import { Button, Menu } from '@mantine/core';
import { IconCheck, IconLanguage } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { SUPPORTED_LANGUAGES } from '@/i18n';

export function LanguageSwitcher() {
    const { t, i18n } = useTranslation();
    const current = SUPPORTED_LANGUAGES.find((language) => language === i18n.resolvedLanguage) ?? 'ru';

    return (
        <Menu position="bottom-end" withinPortal={false}>
            <Menu.Target>
                <Button aria-label={t('language.selectAria')} leftSection={<IconLanguage size={20} />} size="sm" variant="subtle">
                    {t(`language.${current}`)}
                </Button>
            </Menu.Target>
            <Menu.Dropdown>
                {SUPPORTED_LANGUAGES.map((language) => (
                    <Menu.Item
                        key={language}
                        rightSection={language === current ? <IconCheck size={16} /> : undefined}
                        onClick={() => void i18n.changeLanguage(language)}
                    >
                        {t(`language.${language}`)}
                    </Menu.Item>
                ))}
            </Menu.Dropdown>
        </Menu>
    );
}
